import Vue from 'vue'
import VueRouter, { RouteConfig, Route } from 'vue-router'
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import LogoutSuccess from '../views/LogoutSuccess.vue';
import { authenticated, logout } from '../auth2';

Vue.use(VueRouter)

function requireAuth(to: Route, from: Route, next: Function) {
  
  console.log('REQUIRE AUTH');
  if (!authenticated()) {
    console.log('not authenticated - redirecting to login')
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
  } else {
    console.log('authenticated')
    next();
  }
}

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: requireAuth
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue'),
    beforeEnter: requireAuth
  },
  {
    path: '/login', 
    name: 'Login',
    component: Login
  },
  {
    path: '/logout', component: LogoutSuccess,  beforeEnter(to, from, next){
      logout();
      next({
        path: '/login'
      });
    }

  },
]

const router = new VueRouter({
  routes
})

export default router
